import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-support",
	templateUrl: "./support.component.html",
	styleUrls: ["./support.component.scss"]
})
export class SupportComponent implements OnInit {
	public requestContent = "";
	public primary = null;
	public secondary = null;
	public knowledge: APIResults.KnowledgeBase[];

	constructor(private title: Title, private api: ApiService) { }

	async ngOnInit(): Promise<void> {
		const [{ primary, secondary }, knowledge] = await Promise.all([
			this.api.GetUserSupport(),
			this.api.GetKnowledgeBase(),
		]);
		this.primary = primary;
		this.secondary = secondary;
		this.knowledge = knowledge;
		this.title.setTitle(BrandVars.appName + " - Support");
	}

	async SendRequest() {
		await this.api.SendSupportRequest(this.requestContent);
	}
}
